import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  isExternal?: boolean
  searchNow?: boolean
}>()((theme: Theme, { isExternal, searchNow }) => ({
  upperContainter: {
    display: 'flex',
    flexDirection: 'row',
    height: theme.spacing(5.5),
  },
  noResultHeaderContainer: {
    paddingBottom: theme.spacing(5),
    paddingLeft: theme.spacing(2),
  },
  noResultHeading: {
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  noResultSubHeading: {
    marginTop: theme.spacing(2),
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  resultHeadingContainer: {
    width: theme.spacing(27.875),
    height: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  resultHeading: {
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px',
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  resizeFontTextField: {
    width: 255,
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
  },
  defaultValueWidth: {
    width: '220px',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  rowText: {
    color: theme.palette.black.main,
    fontSize: '13px',
  },
  actionIcon: {
    color: theme.palette.icon.main,
    height: '24px',
    width: '24px',
    cursor: 'pointer',
    marginRight: theme.spacing(3),
    '&.css-ptiqhd-MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
    },
  },
  actionIconDisabled: {
    opacity: 0.3,
  },
  adminContainer: {
    padding: theme.spacing(4, 4, 0, 4),
    whiteSpace: 'nowrap',
  },
  labraPOContainer: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  createOfferBtn: {
    marginLeft: 'auto',
    paddingRight: theme.spacing(3),
  },
  alignButton: {
    marginBottom: theme.spacing(isExternal ? 2 : searchNow ? 4 : 5),
  },
  createOfferLink: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  withResaleAuthTab: {
    padding: theme.spacing(0),
  },
  marginTopSpace: {
    marginTop: theme.spacing(isExternal ? 2 : 5),
  },
  toolTipView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownAndProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  dropDownWidth: {
    width: theme.spacing(24),
    '#mui-component-select-product-selector-dropdown': {
      textAlign: 'left',
    },
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  filterComponent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  filterSection: {
    display: 'flex',
    flexDirection: 'column',
    "[role='radiogroup'] div": {
      height: `${theme.spacing(5)} !important`,
    },
    "[role='radiogroup'] div label": {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
    },
  },
  filtersAppliedContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    margin: theme.spacing(0, 2, 2, 0),
  },
  appliedFilter: {
    marginBottom: theme.spacing(-1),
  },
  filterCheckbox: {
    '& label': {
      height: `${theme.spacing(5)} !important`,
      alignItems: 'center !important',
    },
    '& .MuiCheckbox-root': {
      padding: `${theme.spacing(0, 1.5)} !important`,
      margin: 0,
    },
  },
  actionColumn: {
    padding: theme.spacing(2),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    alignSelf: 'stretch',
    minHeight: 0,
    width: '100%',
  },
}))
